// routes.js
import Dashboard from '../pages/Dashboard';
import Login from '../pages/Login';

import EventList from '../pages/events/List';
import EventDetails from '../pages/events/Details';
import AddEvent from '../pages/events/AddUpdate';

import PackageList from '../pages/packages/List';
import AddPackage from '../pages/packages/AddUpdate';

import CategoryList from '../pages/categories/List';
import AddCategory from '../pages/categories/AddUpdate';


import SystemUserList from '../pages/system_users/List';
import AddSystemUser from '../pages/system_users/AddUpdate';

import RoleList from '../pages/roles/List';
import AddRole from '../pages/roles/AddUpdate';

import UserList from '../pages/users/List';
import AddUser from '../pages/users/AddUpdate';

import SubscriptionList from '../pages/subscriptions/List';
import AddSubscription from '../pages/subscriptions/AddUpdate';

import NotFound from '../pages/NotFound';
import Account from '../pages/Account';



const routes = [
    {
        path: '/dashboard',
        component: Dashboard,
        meta: { requiresAuth: true, hideHeader: false }
    },
    {
        path: '/login',
        component: Login,
        meta: { requiresAuth: false, hideHeader: true }
    },
    {
        path: '/events',
        component: EventList,
        meta: { requiresAuth: true , hideHeader: false, permission:'events' }
    },
    {
        path: '/events/create/:id?',
        component: AddEvent,
        meta: { requiresAuth: true , hideHeader: false , permission:'events'}
    },
    {
        path: '/events/:id',
        component: EventDetails,
        meta: { requiresAuth: true , hideHeader: false, permission:'events' }
    },

    {
        path: '/packages/',
        component: PackageList,
        meta: { requiresAuth: true , hideHeader: false, permission:'packages' }
    },
    {
        path: '/packages/create/:id?',
        component: AddPackage,
        meta: { requiresAuth: true , hideHeader: false, permission:'packages' }
    },
    {
        path: '/categories/',
        component: CategoryList,
        meta: { requiresAuth: true , hideHeader: false, permission:'categories' }
    },
    {
        path: '/categories/create/:id?',
        component: AddCategory,
        meta: { requiresAuth: true , hideHeader: false, permission:'categories' }
    },

    {
        path: '/users/',
        component: UserList,
        meta: { requiresAuth: true , hideHeader: false, permission:'users' }
    },
    {
        path: '/users/create/:id?',
        component: AddUser,
        meta: { requiresAuth: true , hideHeader: false, permission:'users' }
    },
    {
        path: '/subscriptions/',
        component: SubscriptionList,
        meta: { requiresAuth: true , hideHeader: false, permission:'subscriptions' }
    },
    {
        path: '/subscriptions/create/:id?',
        component: AddSubscription,
        meta: { requiresAuth: true , hideHeader: false, permission:'subscriptions' }
    },

    {
        path: '/system-users/',
        component: SystemUserList,
        meta: { requiresAuth: true , hideHeader: false, permission:'access-control' }
    },
    {
        path: '/system-users/create/:id?',
        component: AddSystemUser,
        meta: { requiresAuth: true , hideHeader: false , permission:'access-control'}
    },
    {
        path: '/roles/',
        component: RoleList,
        meta: { requiresAuth: true , hideHeader: false, permission:'access-control' }
    },
    {
        path: '/roles/create/:id?',
        component: AddRole,
        meta: { requiresAuth: true , hideHeader: false, permission:'access-control' }
    },
    {
        path: '/account/',
        component: Account,
        meta: { requiresAuth: true , hideHeader: false }
    },

    {
        path: '*',
        component: NotFound,
        meta: { requiresAuth: true , hideHeader: false }
    },
];

export default routes;
